module.exports = __webpack_public_path__ + "img/bg_header.870527bf.png";